<template>
    <full-screen-overlay @close="exit" backTo="Dashboard">

        <dashboard-header header="Create new project" description="Projects are the websites or applications that you'll be creating a search database for..."/>

        <div class="w-full mt-8">
            <form @submit.prevent="!isSubmitting ? sendInvites() : null" class="mt-8 max-w-screen-xs w-full">

                <div class="flex flex-col items-start space-y-5 w-full">
                    <div v-for="(email, index) in emails" :key="index" class="w-full">
                        <base-input v-model.trim="emails[index]" :id="`invite-${index}`" :value="email" type="email" placeholder="Enter their work email..." class="w-full" /> 
                    </div>

                    <button type="button" @click="addNewInvite" class="focus:outline-none focus:shadow-outline text-secondary dark:text-secondary-300 underline rounded-md" ref="inviteButton">+ Invite another user</button>
                </div>

                <base-button bgColor="bg-success" borderColor="border-success" hoverBg="hover:bg-green-400" hoverBorder="hover:border-green-400" class="mt-10 mb-3" icon="tick" iconPosition="left"   type="submit">Send Invitations</base-button>
            </form>
        </div>

    </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { createInvite } from "@/graphql/mutations";
import { authenticationState, loading, error, myProjects, me } from '@/mixins';

export default {
    name: "CreateInvites",
    metaInfo: {
      title: 'Invite Team Mate',
    },
    mixins: [LayoutComponents, authenticationState, loading, error, myProjects, me ],
    data () {
        return {
            isSubmitting: false,
            emails: [
                ''
            ]
        }
    },
    computed: {
        invites () {
            return this.emails.filter(email => email.length).map(email => { return { email } });
        },
    },
    methods: {
        exit () {
            this.$router.push({ name: 'Team', params: { ...this.$route.params }, query: { ...this.$route.query } });
        },
        async sendInvites() {
          this.isSubmitting = true;

          try {

            const changesMade = this.invites.length;
            
            if (changesMade) {
                this.$root.$emit('loading', true);
                await this.$apollo.mutate({
                    mutation: createInvite,
                    variables: {
                        input: {
                            invites: this.invites,
                            projectId: this.authenticationState.selectedProject,
                            sendEmail: true
                        }
                    },
                });
            }
            
            this.exit()
          } catch (error) {
            this.handleError(error);
          }

          this.$root.$emit('loading', false);
          
          this.isSubmitting = false;
      },
      addNewInvite () {
          this.$refs['inviteButton'].blur();
          this.emails.push('');
      }
    }
}
</script>